import React, { useContext } from "react";
import DeviceManagerContext from "../../context";
const isMobile = (viewPort) => ["XS", "S"].includes(viewPort);
const Mobile = ({ children }) => {
  const manager = useContext(DeviceManagerContext);
  if (!manager) {
    throw new Error(`Make sure <Mobile /> is wrapped around a <DeviceManager />`);
  }
  if (isMobile(manager.viewPort)) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return null;
};
var Mobile_default = Mobile;
export {
  Mobile_default as default
};
